import Breadcrumb from "components/Common/Breadcrumb"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Container, Row, Col, Badge } from "reactstrap"
import { FaBell } from "react-icons/fa"
import moment from "moment"
import { fetchData, FetchPutData } from "utils/Common_api_functions"
import secureLocalStorage from "react-secure-storage"

const Notifications = () => {
  const [notifications, setNotifications] = useState([])
  const [loading, setLoading] = useState(false)
  const loggedInUser = secureLocalStorage.getItem("admin_user")

  // Fetch notifications from backend
  const fetchNotifications = async () => {
    try {
      const res = await fetchData(setLoading, `notification/${loggedInUser.id}`)
      if (res?.success) {
        setNotifications(res.data.reverse())
      }
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    fetchNotifications()
  }, [])

  // Mark a notification as read
  const handleMarkAsRead = async notificationId => {
    try {
      await FetchPutData(setLoading, "notification/mark/read", notificationId)
      setNotifications(prev =>
        prev.map(n => (n.id === notificationId ? { ...n, isRead: true } : n))
      )
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb
          title="Dashboard"
          breadcrumbItem="Notifications"
          description="Check notifications regarding payroll updates, missing logs, pending tasks, and employee details."
        />

        <Row>
          {notifications.length === 0 && (
            <Col>
              <Card className="text-center border-0 shadow-sm py-5">
                <CardBody>
                  <FaBell size={48} className="text-muted mb-2" />
                  <h5 className="text-muted">No Notifications Found</h5>
                </CardBody>
              </Card>
            </Col>
          )}

          {notifications.map(notification => (
            <Col md={12} key={notification.id}>
              <Card
                className={`shadow-lg  ${
                  !notification.isRead ? "border border-danger" : "border-0"
                }`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  !notification.isRead && handleMarkAsRead(notification.id)
                }
              >
                <CardBody className="d-flex align-items-start justify-content-between ">
                  <div className="d-flex align-items-start gap-3 w-100">
                    <div className="icon-wrapper">
                      {!notification.isRead ? (
                        <i className="bx bx-bell bx-tada text-danger fs-2" />
                      ) : (
                        <i className="bx bx-bell bx-tada text-info fs-2" />
                      )}
                    </div>
                    <div className="w-100">
                      <div className="d-flex justify-content-between align-items-center">
                        <h6
                          className={`mb-1 ${
                            !notification.isRead ? "fw-bold" : ""
                          }`}
                        >
                          {notification.title}{" "}
                          {!notification.isRead && (
                            <Badge color="primary">New</Badge>
                          )}
                        </h6>
                        <small className="text-primary">
                          {moment
                            .utc(notification.createdAt)
                            .local()
                            .format("DD-MM-YYYY | hh:mm A")}
                        </small>
                      </div>
                      <p className="mb-1 text-muted">
                        {notification.description}
                      </p>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  )
}

export default Notifications
